import React, { useContext } from 'react'

import Page from '../../components/Page'
import StudentMetricsReport from '../../components/sections/reportBuilder/reports/StudentMetricsReport'
import AuthContext from '../../utils/authProvider'

const StudentMetricsReportPage = () => {
  const breadcrumb = [
    {
      path: '/',
      breadcrumbName: 'Home'
    },
    {
      path: '',
      breadcrumbName: 'Student Metrics Report'
    }
  ]
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  return (
    <>
      <Page title='Student Metrics Report' breadcrumb={breadcrumb}>
        <StudentMetricsReport />
      </Page>
    </>
  )
}

export default StudentMetricsReportPage
